import { create } from "zustand";
import type { ExecutionStatusValue } from "./execution.types";

type ExecutionState = {
	status: ExecutionStatusValue | null;
	setStatus: (status: ExecutionStatusValue | null) => void;
	clear: () => void;
};

export const useExecutionStore = create<ExecutionState>((set) => ({
	status: null,
	setStatus: (status) => set({ status }),
	clear: () => set({ status: null }),
}));
